module.exports = __webpack_public_path__ + "img/DKK_Bierflasche_192992202_04.a85bf746.jpg";